export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceAppliedContents: [
        {
          priorityOrder: 2,
          appliedContentsId: 3,
          appliedContentsUuid: 'appliedcontents003',
          serviceContentsId: 1,
          serviceContentsUuid: 'servicecontents001',
          deliveryToKbn: 2,
          snapshotName: "hoambox20210201",
          deviceType: "hoambox",
        },
        {
          priorityOrder: 3,
          appliedContentsId: 2,
          appliedContentsUuid: 'appliedcontents002',
          serviceContentsId: 2,
          serviceContentsUuid: 'servicecontents002',
          deliveryToKbn: 1,
          snapshotName: "hoambox20210201",
          deviceType: "hoambox",
        },
        {
          priorityOrder: 1,
          appliedContentsId: 1,
          appliedContentsUuid: 'appliedcontents001',
          serviceContentsId: 1,
          serviceContentsUuid: 'servicecontents001',
          deliveryToKbn: 1,
          snapshotName: "hoambox20210201",
          deviceType: "hoambox",
        }
      ]
    }
  }
}